import React from 'react';
import {noop} from 'lodash';
import {USYS_DATA_ATTRS} from '@packages/systems/users/constants';
import FormCheckboxInputConfig from '@packages/shared/render/plugins/Form/FormCheckboxInput';
import UserFormCustomCheckboxInput from './RenderUserFormCustomCheckboxInput';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {createIntegratedRootAliasInstance} from '@packages/utilities/integrated-types';
import {usePreviewMode} from '@packages/systems/render';
import {getInPojo, getString} from '@packages/utilities/data-utils';

const UserFormCheckboxInput = Atom.createRender(
  ({attributes, classes, generateAttributes, data, elementId}) => {
    const field = getString(getInPojo(data, ['users', 'field']));
    const fieldType = getString(getInPojo(data, ['users', 'fieldType']));
    const previewMode = usePreviewMode();

    const attributeWithFieldType = field
      ? attributes.set(USYS_DATA_ATTRS.field, field)
      : attributes;

    const props = generateAttributes(
      fieldType
        ? attributeWithFieldType.set(USYS_DATA_ATTRS.fieldType, fieldType)
        : attributeWithFieldType,
      classes
    );

    const checked = Boolean(props.checked);
    let finalprops;
    // We are using "key" on this input so we can switch between controlled and
    // uncontrolled for the same input. The different key causes a new instance to be
    // created on render, rather than using the existing one.
    if (previewMode) {
      finalprops = {
        ...props,
        defaultChecked: checked,
        checked: undefined,
        key: elementId + '-preview',
      };
    } else {
      finalprops = {
        ...props,
        checked,
        onChange: noop,
        key: elementId,
      };
    }
    return <input {...finalprops} />;
  }
);

const render = Atom.createRender((props) => {
  const inputType = getString(getInPojo(props.data, ['inputType']));
  return inputType === 'custom' ? (
    <UserFormCustomCheckboxInput {...props} />
  ) : (
    <UserFormCheckboxInput {...props} />
  );
});

export default Atom.create({
  ...Atom.getConfigShape(FormCheckboxInputConfig),
  constraints: {
    pinToParent: true,
    ancestors: [
      {
        is: ['UserSignUpForm', 'UserAccountForm'],
        name: 'User Form',
        rule: 'ExactlyOne',
      },
    ],
  },
  render,
  dataType: createIntegratedRootAliasInstance(
    qualify(Plugins.name('Form'), typeName('UserFormCheckbox'))
  ),
});
